import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Input,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { SingleRowAssessmentPayment } from "../../../components/List/SingleRowAssessmentPayment";
import AssessementDataService from "../../../services/Assessment";
import ExpertDataService from "../../../services/Expert";
import NotificationService from "../../../services/Notification";
import { default as ReactSelect } from "react-select";

export const PaymentList = () => {
  const token = localStorage.getItem("logged_in_user_token");
  const toast = useToast();
  const localPagesize = localStorage.getItem(
    "assessment-list-pageSize-content"
  );
  const newlocalPagesize = localPagesize ? JSON.parse(localPagesize) : 7;

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState<any>([]);
  const [totalPayments, setTotalPayments] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(newlocalPagesize);
  const [totalPages, setTotalPages] = useState(0);

  const [expertList, setExpertList] = useState<any>([]);
  const [userList, setUserList] = useState<any>([]);
  const [loadingLists, setLoadingLists] = useState(true);

  const [expert, setExpert] = useState("");
  const [email, setEmail] = useState("");

  const options = expertList.map((el: any) => ({
    value: el._id,
    label: el.data.full_name,
  }));

  const fetchExperts = async () => {
    setLoadingLists(true);
    try {
      const expertRes = await ExpertDataService.getExperts(token);
      setExpertList(expertRes.data);
      const userRes = await NotificationService.getAllUsers();
      setUserList(userRes.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingLists(false);
    }
  };

  const fetchData = () => {
    setIsLoading(true);
    AssessementDataService.getPayments(pageSize, pageNo, token, expert, email)
      .then((res) => {
        const data = res.data.data;
        setData(data);
        setTotalPayments(res.data.pagination.totalRecords);
        setTotalPages(res.data.pagination.totalPages);
        setIsLoading(false);
        // fetchExperts()
      })
      .catch((e) => {
        setIsLoading(false);
        if (e.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
        console.log(e);
      });
  };

  useEffect(() => {
    fetchData();
    fetchExperts();
  }, [pageNo, pageSize, expert]);

  return (
    <>
      <div className="main-wrapper">
        <div className="page_title py-2">Payment List</div>
        <div className=" p-4">
          <div className="top_section_container">
            <div className="top_section_lower_container">
              <div
                className="nested p-lg-0"
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <div className="input-group">
                  <div className="input-group-append">
                    <button
                      className="btn action-btn"
                      type="button"
                      onClick={() => {
                        navigate("/assessment/generatepayment");
                      }}
                    >
                      Generate Link
                    </button>
                  </div>
                </div>
                <Flex p={4} alignItems="start" justifyContent="end" gap={8}>
                  <Box w="270px">
                    <ReactSelect
                      id="expert"
                      name="expert"
                      options={options}
                      placeholder="Filter Expert"
                      isClearable
                      value={options.find(
                        (option: any) => option.value === expert
                      )}
                      onChange={(option) =>
                        setExpert(option ? option.value : "")
                      }
                      classNamePrefix="react-select"
                    />
                  </Box>
                  <Flex display="flex" alignItems="flex-end" w="350px">
                    <Input
                      id="searchquery"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Search By Email"
                      borderRadius="md"
                      borderRightRadius={0}
                      borderWidth="1px"
                      color="#327171"
                      bg="white"
                      focusBorderColor="transparent"
                      // _placeholder={{ color: "gray.500" }}
                      borderColor="#327171"
                      _hover={{ borderColor: "gray.200" }}
                      _focus={{ borderColor: "gray.200" }}
                    />
                    <Button
                      size="md"
                      borderRadius="md"
                      borderLeftRadius={0}
                      p={5}
                      colorScheme="whiteAlpha"
                      bg="#327171"
                      onClick={() => fetchData()}
                    >
                      Search
                    </Button>
                  </Flex>
                </Flex>
              </div>
            </div>
          </div>

          {/* Main secttion */}
          <div className="main-section" style={{ overflowX: "auto" }}>
            <table className="table">
              <thead>
                <tr>
                  <th>Amount</th>
                  <th>URL</th>
                  <th>Session Type</th>
                  <th>Booking Type</th>
                  <th>Expert</th>
                  <th>Name</th>
                  <th>Contact</th>
                  <th>Email</th>
                  <th>User Existence</th>
                  <th>Status</th>
                  <th>Add Booking</th>
                  <th>Remove</th>
                </tr>
              </thead>
              <tbody>
                {data.length > 0 ? (
                  data.map((el: any) => (
                    <SingleRowAssessmentPayment
                      key={el.id}
                      data={el}
                      experts={expertList}
                      users={userList}
                      func={fetchData}
                    />
                  ))
                ) : (
                  <h1 className="no-data">No Data Found</h1>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination section */}
          <div className="row m-0 pagination pt-5">
            <div className="col-sm-6 p-lg-0">
              <p>
                Showing {(pageNo - 1) * pageSize + 1} to{" "}
                {pageNo * pageSize > totalPayments
                  ? totalPayments
                  : pageNo * pageSize}{" "}
                of {totalPayments} entries
              </p>
            </div>
            <div className="col-sm-6 p-lg-0 text-right">
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className={
                    pageNo === 1
                      ? "btn action-btn disabledButton "
                      : "btn action-btn"
                  }
                  onClick={() => setPageNo(pageNo - 1)}
                  disabled={pageNo === 1 ? true : false}
                >
                  {"<< Previous"}
                </button>
                <button type="button" className="btn action-btn selected">
                  {pageNo}
                </button>
                <button
                  type="button"
                  className={
                    pageNo === totalPages || totalPages === 0
                      ? "btn action-btn disabledButton "
                      : "btn action-btn"
                  }
                  onClick={() => setPageNo(pageNo + 1)}
                  disabled={
                    pageNo === totalPages || totalPages === 0 ? true : false
                  }
                >
                  {"Next >>"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
